<svg
	width="100%"
	height="120"
	viewBox="0 0 1440 120"
	fill="none"
	style="transform: scale(-1,-1)"
	xmlns="http://www.w3.org/2000/svg"
	preserveAspectRatio="xMidYMid slice"
	class="footer__wave"
>
	<path
		d="M0 0L48 8.875C96 17.9167 192 35.4167 288 53.3333C384 71.25 480 88.75 576 82.2083C672 75.4167 768 44.5833 864 26.6667C960 8.75 1056 4.58333 1152 11.125C1248 17.9167 1344 35.4167 1392 44.4583L1440 53.3333V120H1392C1344 120 1248 120 1152 120C1056 120 960 120 864 120C768 120 672 120 576 120C480 120 384 120 288 120C192 120 96 120 48 120H0V0Z"
		fill="var(--body-background-color)"
	/>
</svg>
<!--<style>
	.footer-wave > path {
		animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
		animation-delay: -2s;
		animation-duration: 7s;
	}
	@keyframes move-forever {
		0% {
			transform: translate3d(-90px, 0, 0);
		}
		100% {
			transform: translate3d(85px, 0, 0);
		}
	}
</style>-->
